export default __webpack_public_path__ + "static/media/one.a3146128.svg";